<div class="flex-container-jobcard-timer" *ngIf="jobcardTimerEnabled && showTimer && jobcard?.id && elapsedDuration">
    <div class="timer-container"
        [ngClass]="{'over-duration': isTimerOverdue()}">
        <div class="timer-details">
            <div class="timer-clock">
                <div class="clock-display">{{elapsedDuration}}</div>
            </div>
            <div class="timer-actions" *ngIf="jobcard.statusID < 40">
                <hub-button *ngIf="activeTimer" [icon]="'pause'" [style]="'lavendar-solid'" [size]="'md'"
                    [disabled]="activeTimer.pausing || activeTimer.stopping" [loading]="activeTimer.pausing"
                    (click)="onPauseTimer()">
                </hub-button>
                <hub-button *ngIf="activeTimer" [icon]="'stop'" [style]="'lavendar-solid'" [size]="'md'"
                    [disabled]="activeTimer.stopping || activeTimer.pausing" [loading]="activeTimer.stopping"
                    (click)="onStopTimer()">
                </hub-button>
                <hub-button *ngIf="!activeTimer" [icon]="'play'" [style]="'lavendar-solid'" [size]="'md'"
                    (click)="onStartTimer()" [loading]="timerStarting" [disabled]="timerStarting">
                </hub-button>
            </div>
        </div>
    </div>
    <hub-button [icon]="'square-poll-horizontal'" [size]="'xl'" *ngIf="timers?.length > 0"
        pTooltip="{{ 'bikeshop.workshop.jobcard.timer_audit_trail' | translate }}" tooltipPosition="top"
        [style]="'outline'" (buttonClick)="openJobCardLogs()" />
</div>